var transX = function transX(props) {
  return props.fullScreen ? '0%' : '-50%';
};
var transY = function transY(props) {
  return props.fullScreen || props.modalOffsetTop ? '0%' : '-50%';
};

export { transX, transY };
